import Head from "next/head";
import Link from "next/link";
import { ONBOARDING_SCREEN_EXAMPLES } from "@medbillai/app/components/OnboardingScreen/examples";
import { Body3, YStack } from "@medbillai/ui";
import { AuthGate } from "../../../utils/AuthGate";
import type { NextPageWithLayout } from "../../_app";
const Page: NextPageWithLayout = () => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
        <title>OnboardingScreen examples</title>
      </Head>
      <YStack padding="$sp3" gap="$sp2" data-sentry-element="YStack" data-sentry-source-file="index.tsx">
        {Object.entries(ONBOARDING_SCREEN_EXAMPLES).map(([slug, {
        label
      }]) => <Link key={slug} href={`/internal/onboarding-screen/${slug}`} style={{
        textDecoration: "none"
      }}>
            <Body3 color="$textAccent">→ {label}</Body3>
          </Link>)}
      </YStack>
    </>;
};
Page.getLayout = (page: React.ReactNode) => {
  if (process.env.NODE_ENV === "production") {
    return <AuthGate>{page}</AuthGate>;
  }
  return page;
};
export default Page;